import { Section } from '../Section';
import React from 'react';
import QAItem from './QAitem';
import QA from '../../data/QuestionsAnswers';
import { SectionTitle } from '../Typography';

const QALandingPage = ({ fromPage }) => {
  const [openedItem, setOpenedItem] = React.useState(null);
  const container = React.useRef();

  const QAfiltered = QA.filter((item) => {
    if (item.courses.indexOf(fromPage) !== -1) {
      return item;
    } else return null;
  });

  return (
    <Section landing>
      <SectionTitle isMobileCenter isCenter css={{ marginBottom: 10, width: '100%' }}>
        Questions fréquentes
      </SectionTitle>
      <div
        css={{
          paddingTop: 50,
          width: '100%',
        }}
      >
        {QAfiltered.map((item, index) => (
          <QAItem
            key={item.question}
            question={item.question}
            answer={item.answer}
            isOpen={openedItem === index}
            onQuestionClick={() => {
              setOpenedItem((prev) => (prev === index ? null : index));
            }}
            containerRef={openedItem === index ? container : undefined}
          />
        ))}
      </div>
    </Section>
  );
};

export default QALandingPage;
